import "babel-polyfill";
import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import App from "./App";
import Const from "./constants";
import Tremol from "./assets/fp/fp_core";
import FpMixin from "./assets/fp/fp_mixin";


Vue.use(Vuetify);
const vuetify = new Vuetify();
Vue.config.productionTip = false;


Array.prototype.asyncForEach = async function (callback) {
  var array = this;
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

Number.prototype.roundTo = function (digits) { //много тъп краден код...
  var n = this;
  var negative = false;
  if (digits === undefined) {
    digits = 0;
  }
  if (n < 0) {
    negative = true;
    n = n * -1;
  }
  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  n = (Math.round(n) / multiplicator).toFixed(2);
  if (negative) {
    n = (n * -1).toFixed(2);
  }
  return Number(n);
}

/** 
 * @typedef uiSettings
 */
var uiSettingsObj = {
  menuInLeft: localStorage.getItem(Const.SettingsMenuInLeft) == "true",
  searchInTop: localStorage.getItem(Const.SettingsSearchInTop) == "true",
  printVatInReceipt: localStorage.getItem(Const.PrintVatInReceipt),
  receiptFormat: localStorage.getItem(Const.ReceiptFormat),
  touchScreenMode: (localStorage.getItem(Const.SettingsCloseReceiptAfterPayment) || "false") == "true",
  closeAfterPayment: (localStorage.getItem(Const.SettingsCloseReceiptAfterPayment) || "true") == "true",
  showPaymentValues: localStorage.getItem(Const.SettingsShowPaymentValues) == "true",
  showCloseBarcode: localStorage.getItem(Const.SettingsShowCloseReceiptBarcode) == "true",
  noFullScreen: localStorage.getItem(Const.SettingsNoFullScreen) == "true",
  noConfirmOnKeyboardSale: localStorage.getItem(Const.SettingsNoConfirmOnKeyboardSale) == "true",
  showDrawerButton: localStorage.getItem(Const.SettingsShowDrawer) == "true",
  showFreePrice: localStorage.getItem(Const.SettingsShowFreePrice) == "true",
  viewType: localStorage.getItem(Const.CurrentViewType) || Const.ViewTypes[1],
  articleLimit: localStorage.getItem(Const.CurrentArticleLimit) || Const.ArticleLimits[0],
  articleFrom: Number(localStorage.getItem(Const.CurrentArticleFrom)) || 1,
  articleTo: Number(localStorage.getItem(Const.CurrentArticleTo)) || 500,
  clientsLimit: localStorage.getItem(Const.CurrentClientsLimit) || Const.ClientsLimits[0],
  externalDisplayPort: localStorage.getItem(Const.ExternalDisplayPortName) || null,
  externalDisplayCodePage: localStorage.getItem(Const.ExternalDisplayCodePage) || Const.ExternalDisplayCodePage[0],
  scalePort: localStorage.getItem(Const.ScalePortName) || null,
  scaleType: localStorage.getItem(Const.ScaleType) || null,
};

var fpp = new FpMixin();

Vue.mixin({
  data() {
    return {
      fp: fpp,
      uiSettings: uiSettingsObj,
      wWidth: window.innerWidth,
      isOnFullScreen: false,
    }
  },
  computed: {
    /** @return {Boolean}  */
    isInDarkMode() {
      return this.$vuetify.theme.dark;
    },
    /** @return {Boolean}  */
    isOnAndroid() {
      return Tremol.FP.IsOnAndroid();
    },
    isOnPhone() {
      return this.$vuetify.breakpoint.name == "xs";
    },
    /** @return {Boolean}  */
    isOnMobile() {
      //return this.$vuetify.breakpoint.mobile;
      switch (this.$vuetify.breakpoint.name) {
        case "md":
        case "lg":
        case "xl":
          return false;
        case "sm":
        case "xs":
        default:
          return true;
      }
    },
    /** @return {Boolean}  */
    isWindowNotWideEnough() {
      return this.wWidth <= 450
    },
    /** @return {Number} */
    mobileReceiptHeight() {
      return this.isOnMobile ? 52 : 0;
    },
    /** @return {Number} */
    searchToolbarHeight() {
      return 60;
    },
    /** @return {Number} */
    headerFooterHeight() {
      return this.$vuetify.application.top + this.$vuetify.application.footer;
    },
    /** @return {Number} */
    menuWidth() {
      return this.$vuetify.application.right + this.$vuetify.application.left;
    },
  },
  methods: {
    requestFullScreen() {
      var elem = document.documentElement;
      if (this.isOnFullScreen == false) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE/Edge */
          document.msExitFullscreen();
        }
      }
    },
    windowResizeEvent() {
      this.wWidth = window.innerWidth;
    },
    fullScreenChanged() {
      if (document.fullScreen ||
        document.msFullscreenElement ||
        document.mozFullScreen ||
        document.webkitIsFullScreen) {
        this.isOnFullScreen = true;
      } else {
        this.isOnFullScreen = false;
      }
    },
    startAndroidCamera() {

      if (this.isOnAndroid()) {

        // Older browsers might not implement mediaDevices at all, so we set an empty object first
        if (navigator.mediaDevices === undefined) {
          navigator.mediaDevices = {};
        }

        // Some browsers partially implement mediaDevices. We can't just assign an object
        // with getUserMedia as it would overwrite existing properties.
        // Here, we will just add the getUserMedia property if it's missing.
        if (navigator.mediaDevices.getUserMedia === undefined) {
          navigator.mediaDevices.getUserMedia = function (constraints) {

            // First get ahold of the legacy getUserMedia, if present
            var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

            // Some browsers just don't implement it - return a rejected promise with an error
            // to keep a consistent interface
            if (!getUserMedia) {
              return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
            }

            // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
            return new Promise(function (resolve, reject) {
              getUserMedia.call(navigator, constraints, resolve, reject);
            });
          }
        }
        navigator.mediaDevices.getUserMedia({ video: true });
        window.alert("asdf " + navigator.mediaDevices);
      }
    },
    checkDecimals(value, decimals) {
      if (isNaN(Number(value)) || Number(value) != this.roundTo(value, decimals)) return false;
      return true
    },
    roundTo(n, digits) { //много тъп краден код...
      var negative = false;
      if (digits === undefined) {
        digits = 0;
      }
      if (n < 0) {
        negative = true;
        n = n * -1;
      }
      var multiplicator = Math.pow(10, digits);
      n = parseFloat((n * multiplicator).toFixed(11));
      n = (Math.round(n) / multiplicator).toFixed(2);
      if (negative) {
        n = (n * -1).toFixed(2);
      }
      return Number(n);
    },
  },
  created() {
    document.addEventListener('fullscreenchange', this.fullScreenChanged);
    document.addEventListener('MSFullscreenChange', this.fullScreenChanged);
    window.addEventListener("resize", this.windowResizeEvent);
    //this.startAndroidCamera();

  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.fullScreenChanged);
    document.removeEventListener('MSFullscreenChange', this.fullScreenChanged);
    window.removeEventListener("resize", this.windowResizeEvent);
  }
});

new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount("#app");